"use client";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { StoryblokComponent } from "@trydig/storyblok";
import { useGlobal } from "@/features/global/GlobalContext";
import { useHeader } from "@/features/navigation/Header/components/HeaderProvider";

export const DesktopLinks = () => {
	const { preview } = useGlobal();
	const { content } = useHeader();

	return (
		<div className="hidden lg:block desktop-menu h-full">
			<NavigationMenu.List className="flex gap-2 h-full">
				{content?.map((section, i) => {
					if (section.component === "link") {
						return (
							<NavigationMenu.Item key={i}>
								<StoryblokComponent
									blok={section}
									preview={preview}
									className="flex items-center font-display p-1-5 font-[300] leading-[125%] underline-0 no-underline text-sm"
									rightIcon={false}
									unstyled
								/>
							</NavigationMenu.Item>
						);
					}

					return (
						<NavigationMenu.Item key={i}>
							<StoryblokComponent blok={section} preview={preview} />
						</NavigationMenu.Item>
					);
				})}
			</NavigationMenu.List>
		</div>
	);
};
